import { Link } from 'react-router-dom'
import '../styles/Home.css'
import '../styles/HomeSecoes.css'
import { useScrollReveal } from '../shared/hooks/useScrollReveal'
import { useCountUp } from '../shared/hooks/useCountUp'
import { Spotlight } from '@/components/ui/spotlight'

function StatBox({ num, suffix, label, icon }: { num: number; suffix: string; label: string; icon: string }) {
  const { count, ref } = useCountUp(num)
  return (
    <div ref={ref} className="hs-stat" data-sr data-delay="0">
      <span className="hs-stat-icon"><i className={`fa-solid ${icon}`} aria-hidden="true" /></span>
      <div>
        <span className="hs-stat-num">{count.toLocaleString('pt-BR')}{suffix}</span>
        <span className="hs-stat-lbl">{label}</span>
      </div>
    </div>
  )
}

/* ── Data ── */
const stats = [
  { num: 20,   suffix: '+', label: 'Anos de mercado',   icon: 'fa-calendar-check' },
  { num: 1500, suffix: '+', label: 'Clientes ativos',   icon: 'fa-users' },
  { num: 9,    suffix: '+', label: 'Estados atendidos', icon: 'fa-map-location-dot' },
]

const diferenciais = [
  {
    icon: 'fa-chart-line', titulo: 'Controle Total',
    desc: 'Gerencie vendas, estoque, financeiro e fiscal integrados em uma única plataforma. Sem planilhas, sem retrabalho.',
    foto: '/img/solucoes/solucoes.jpg', w: 2560, h: 1709, alt: 'Notebook com gráficos de gestão na tela',
  },
  {
    icon: 'fa-headset', titulo: 'Suporte Especializado',
    desc: 'Equipe técnica local que conhece o seu setor e responde com rapidez quando você mais precisa.',
    foto: '/img/galeria/quantum-galeria-img1.png', w: 1024, h: 576, alt: 'Sala de suporte da Quantum com a equipe nos computadores',
  },
  {
    icon: 'fa-shield-halved', titulo: 'Segurança de Dados',
    desc: 'Backups automáticos, criptografia e controle de acesso por usuário. Seus dados sempre protegidos.',
    foto: '/img/geral/banner.webp', w: 1920, h: 1116, alt: 'Pessoa segurando ícones digitais de tecnologia',
  },
  {
    icon: 'fa-rotate', titulo: 'Atualizações Inclusas',
    desc: 'NF-e, NFC-e e SPED sempre atualizados conforme a legislação. Sem custo extra, sem surpresas.',
    foto: '/img/solucoes/entrada.webp', w: 689, h: 420, alt: 'Ilustração de uma nota fiscal eletrônica',
  },
]

const segmentos = [
  { slug: 'supermercado',               label: 'Supermercado',                 foto: '/img/solucoes/supermercado/supermarket.jpg',                 w: 1280, h: 958 },
  { slug: 'autopecas',                  label: 'Autopeças',                    foto: '/img/solucoes/autopecas/auto.jpg',                           w: 2560, h: 1707 },
  { slug: 'material-de-construcao',     label: 'Material de Construção',       foto: '/img/solucoes/materialdeconstrucao/material.jpg',            w: 1024, h: 768 },
  { slug: 'distribuidoras-atacadistas', label: 'Distribuidoras e Atacadistas', foto: '/img/solucoes/distribuidora/distribuidora.jpg',               w: 2560, h: 1703 },
  { slug: 'loja-de-roupas',             label: 'Loja de Roupas',               foto: '/img/solucoes/estoquelojaderoupas.jpg',                      w: 1024, h: 683 },
  { slug: 'agropecuaria-e-petshop',     label: 'Agropecuária e Pet Shop',      foto: '/img/solucoes/agropecuariaepetshop/petshop.jpg',             w: 2560, h: 1708 },
  { slug: 'papelaria',                  label: 'Papelaria',                    foto: '/img/solucoes/acervo/papelaria-material-escolar.webp',       w: 1024, h: 683 },
  { slug: 'restaurante',                label: 'Restaurante e Lanchonete',     foto: '/img/solucoes/restaurante/restaurante.jpg',                  w: 2560, h: 1707 },
  { slug: 'posto-de-combustivel',       label: 'Posto de Combustível',         foto: '/img/solucoes/postodecombustivel/posto.jpg',                 w: 2560, h: 1707 },
  { slug: 'engenharia',                 label: 'Engenharia e Construção',      foto: '/img/solucoes/engenhariaeconstrucao/engeconstrucao.jpeg',    w: 950,  h: 633 },
  { slug: 'distribuidora-de-agua',      label: 'Distribuidora de Água',        foto: '/img/solucoes/distribuidoradeagua/distribuidora.jpg',        w: 1200, h: 630 },
  { slug: 'e-commerce',                 label: 'E-commerce',                   foto: '/img/solucoes/ecommerce/ecommerce.jpg',                      w: 1200, h: 628 },
  { slug: 'otica',                      label: 'Ótica',                        foto: '/img/solucoes/otica/otica.jpg',                              w: 2560, h: 1706 },
]

const clientes = [
  { nome: 'Auto Vidros Santa Izabel', img: '/img/clientes/supcatarinense.jpg' },
  { nome: 'Jode',                     img: '/img/clientes/logo-jode.png' },
  { nome: 'Máq Pão',                  img: '/img/clientes/maq-pao.png' },
  { nome: 'Mega Supermercado',        img: '/img/clientes/uniao.webp' },
  { nome: 'Papelaria Moderna',        img: '/img/clientes/papelaria-moderna.png' },
  { nome: 'Valadares',                img: '/img/clientes/valadares.png' },
]

const beneficios = [
  'Implantação e treinamento inclusos',
  'Suporte técnico presencial e remoto',
  'Integração com NF-e, NFC-e e SPED',
  'Funciona online e offline',
]

const MAPA_LINK = 'https://www.google.com/maps/search/?api=1&query=Quantum+Sistemas+de+Gest%C3%A3o+Palmas+TO'

/* ── Component ── */
export default function Home() {
  useScrollReveal()

  return (
    <div className="hm">

      {/* ══ HERO ══ */}
      <section className="h-screen supports-[height:100dvh]:h-[100dvh] w-full flex items-center justify-center bg-quantum-navy antialiased bg-grid-white/[0.02] relative overflow-hidden">
        {/* Vídeo de fundo (teste) com véu navy para manter o texto legível */}
        <video
          className="absolute inset-0 z-0 h-full w-full object-cover pointer-events-none"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/hero.webm" type="video/webm" />
          <source src="/hero.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 z-0 bg-quantum-navy/70 pointer-events-none" />
        <Spotlight
          className="-top-40 left-0 md:left-60 md:-top-20 h-[220%] w-[190%] md:h-[169%] md:w-[138%]"
          fill="white"
        />
        <div className=" p-4 max-w-7xl  mx-auto relative z-10  w-full">
          <h1 className="text-4xl md:text-7xl font-bold text-center bg-clip-text text-transparent bg-gradient-to-b from-white to-[#9DB4DC]">
            Gestão completa <br />
            <span className="bg-gradient-to-r from-quantum-red to-[#ff6a5f] bg-clip-text text-transparent">
              para crescer sem complicação.
            </span>
          </h1>
          <p className="mt-4 font-normal text-base text-blue-100/80 max-w-lg text-center mx-auto">
            O Sistema Quantum integra vendas, estoque, financeiro e fiscal em
            uma única plataforma — desenvolvida para o comércio do Brasil
            Central há mais de 20 anos.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/agendar-visita"
              className="inline-flex items-center justify-center rounded-md bg-quantum-red px-6 py-3 text-sm font-semibold text-white transition hover:bg-quantum-red/90"
            >
              Agendar Demonstração Gratuita
            </Link>
            <Link
              to="/solucoes"
              className="inline-flex items-center justify-center rounded-md border border-quantum-blue bg-quantum-blue/20 px-6 py-3 text-sm font-semibold text-blue-100 transition hover:bg-quantum-blue"
            >
              Ver Soluções
            </Link>
          </div>
        </div>
      </section>

      {/* ══ NÚMEROS ══ */}
      <section className="hs-stats">
        <div className="hs-stats-inner">
          {stats.map(s => <StatBox key={s.label} {...s} />)}
        </div>
      </section>

      {/* ══ DIFERENCIAIS ══ */}
      <section className="hs-section hs-claro">
        <div className="hs-inner">
          <div className="hs-header" data-sr data-delay="0">
            <span className="hs-eyebrow">Por que o Quantum?</span>
            <h2 className="hs-title">Tudo que seu negócio precisa, em um só lugar</h2>
            <p className="hs-sub">
              Desenvolvido para o mercado brasileiro, com suporte local e atualizações constantes para manter você em conformidade.
            </p>
          </div>
          <div className="hs-dif-grid">
            {diferenciais.map((d, i) => (
              <div key={d.titulo} className="hs-dif-card" data-sr data-delay={String(i * 90)}>
                <div className="hs-dif-foto">
                  <img src={d.foto} width={d.w} height={d.h} alt={d.alt} loading="lazy" decoding="async" />
                  <span className="hs-dif-icon"><i className={`fa-solid ${d.icon}`} aria-hidden="true" /></span>
                </div>
                <div className="hs-dif-corpo">
                  <h3 className="hs-dif-title">{d.titulo}</h3>
                  <p className="hs-dif-desc">{d.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ SEGMENTOS ══ */}
      <section className="hs-section">
        <div className="hs-inner">
          <div className="hs-header" data-sr data-delay="0">
            <span className="hs-eyebrow">Soluções por segmento</span>
            <h2 className="hs-title">Feito para o seu tipo de negócio</h2>
            <p className="hs-sub">
              O Quantum se adapta ao seu ramo com funcionalidades específicas para cada setor do comércio.
            </p>
          </div>
          <div className="hs-seg-grid" data-sr data-delay="80">
            {segmentos.map(s => (
              <Link key={s.slug} to={`/solucoes/${s.slug}`} className="hs-seg-card">
                <img src={s.foto} width={s.w} height={s.h} alt="" loading="lazy" decoding="async" />
                <span className="hs-seg-label">{s.label}</span>
              </Link>
            ))}
            <Link to="/solucoes" className="hs-seg-card hs-seg-todas">
              <span className="hs-seg-todas-titulo">Não achou o seu ramo?</span>
              <span className="hs-seg-todas-link">
                Ver todas as soluções <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* ══ SOBRE NÓS ══ */}
      <section className="hs-section hs-escuro">
        <div className="hs-inner hs-sobre-grid">
          <div data-sr data-delay="0">
            <span className="hs-eyebrow">Sobre nós</span>
            <h2 className="hs-title hs-title--claro">
              Mais de 20 anos cuidando da gestão de empresas em todo o Brasil
            </h2>
            <Link to="/quem-somos" className="hs-btn-red">
              Conheça a Quantum
              <i className="fa-solid fa-arrow-right" aria-hidden="true" />
            </Link>
          </div>
          <div data-sr data-delay="120">
            <p className="hs-sobre-p">
              O Sistema Quantum nasceu em Palmas-TO com o propósito de simplificar a gestão empresarial. Hoje atendemos centenas de clientes em todo o Brasil, com soluções que se adaptam às necessidades de cada segmento e tecnologia em constante evolução.
            </p>
            <ul className="hs-checklist">
              {beneficios.map(b => (
                <li key={b}>
                  <i className="fa-solid fa-circle-check" aria-hidden="true" />
                  {b}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ══ CLIENTES ══ */}
      <section className="hs-section hs-clientes">
        <div className="hs-inner">
          <div className="hs-header hs-header--curto" data-sr data-delay="0">
            <span className="hs-eyebrow">Nossos clientes</span>
            <h2 className="hs-title">Empresas que confiam no Quantum</h2>
          </div>
          <div className="hs-logos" data-sr data-delay="80">
            {clientes.map(({ nome, img }) => (
              <div key={nome} className="hs-logo">
                <img src={img} width={188} height={188} alt={nome} loading="lazy" decoding="async" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ CTA ══ */}
      <section className="hs-cta">
        <div className="hs-cta-marca" aria-hidden="true">QUANTUM</div>
        <div className="hs-cta-inner" data-sr data-delay="0">
          <span className="hs-cta-eyebrow">Próximo passo</span>
          <h2 className="hs-cta-title">Quer ver o Sistema Quantum em ação?</h2>
          <p className="hs-cta-sub">
            Agende uma visita gratuita e deixe nossos consultores mostrarem como o Quantum pode transformar a gestão do seu negócio.
          </p>
          <div className="hs-cta-btns">
            <Link to="/agendar-visita" className="hs-btn-white">Agendar Demonstração Gratuita</Link>
            <a href="https://wa.me/5563984042819" target="_blank" rel="noreferrer" className="hs-btn-outline">
              <i className="fa-brands fa-whatsapp" aria-hidden="true" />
              (63)&nbsp;98404-2819
            </a>
          </div>
        </div>
      </section>

      {/* ══ ONDE ESTAMOS ══ */}
      <section className="hs-section hs-claro">
        <div className="hs-inner hs-mapa-grid">
          <div className="hs-mapa-card" data-sr data-delay="0">
            <img className="hs-mapa-foto" src="/img/galeria/quantumfrente.jpeg" width={720} height={1280} alt="Fachada da sede da Quantum Sistemas de Gestão" loading="lazy" decoding="async" />
            <div className="hs-mapa-corpo">
              <span className="hs-eyebrow">Onde estamos</span>
              <h2 className="hs-mapa-title">Nossa sede em Palmas – TO</h2>
              <ul className="hs-contatos">
                <li>
                  <i className="fa-solid fa-location-dot" aria-hidden="true" />
                  Palmas – TO, Brasil
                </li>
                <li>
                  <i className="fa-brands fa-whatsapp" aria-hidden="true" />
                  <a href="https://wa.me/5563984042819" target="_blank" rel="noreferrer">(63)&nbsp;98404-2819</a>
                </li>
                <li>
                  <i className="fa-solid fa-envelope" aria-hidden="true" />
                  <a href="mailto:contato@sistemaquantum.com.br">contato@sistemaquantum.com.br</a>
                </li>
              </ul>
              <a href={MAPA_LINK} target="_blank" rel="noreferrer" className="hs-btn-blue">
                <i className="fa-solid fa-diamond-turn-right" aria-hidden="true" />
                Como chegar
              </a>
            </div>
          </div>
          <div className="hs-mapa" data-sr data-delay="120">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3926.2289773589864!2d-48.32242718581444!3d-10.243107813756446!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x933b3478108434ab%3A0xc474a2f8e30aad2a!2sQuantum%20Sistemas%20de%20Gest%C3%A3o!5e0!3m2!1spt-BR!2sbr!4v1662404673613!5m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0, display: 'block' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Sistema Quantum"
            />
          </div>
        </div>
      </section>

    </div>
  )
}
